@if (call.audioUrl !== null) {
  <audio controls id="player" #player (contextmenu)="$event.preventDefault()">
    <source [src]="call.audioUrl" type="audio/mpeg" />
  </audio>
  <app-media-player-controller
    [currentTime]="getTime()"
    [duration]="getDuration()"
    [isPlaying]="isPlaying"
    [displayFullscreenButton]="false"
    [allowDownload]="allowDownload"
    [displaySpeakerLabelingModeButton]="displaySpeakerLabelingModeButton"
    [pauseIntervals]="call.pauseIntervals"
    (play)="play()"
    (pause)="pause()"
    (seek)="seek($event)"
    (changePlaybackRate)="changePlaybackRate($event)"
    (changeVolume)="changeVolume($event)"
    (jumpToNextSpeaker)="handleJumpToNextSpeaker()"
    (download)="download()"
  ></app-media-player-controller>
}
